"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _user = require("@/api/user/user");
var _validate = require("@/libs/validate1.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      editDia: false,
      isAdd: true,
      diaTitle: "注册",
      tabsActNum: 0,
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "name",
        placeholder: "姓名"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "姓名",
        prop: "name",
        isShow: true,
        width: "100"
      }, {
        name: "类型",
        prop: "type",
        isShow: true,
        width: "100",
        isFormats: true
      }, {
        name: "性别",
        prop: "sex",
        isShow: true,
        width: "100",
        isFormats: true
      }, {
        name: "所学专业",
        prop: "major",
        isShow: true,
        width: "200"
      }, {
        name: "身份证号",
        prop: "idCard",
        isShow: true,
        width: "100"
      }, {
        name: "手机号",
        prop: "phone",
        isShow: true,
        width: "150"
      }, {
        name: "邮箱",
        prop: "mail",
        isShow: true,
        width: "200"
      }, {
        name: "所属学校",
        prop: "schoolName",
        isShow: true,
        width: "200"
      }, {
        name: "状态",
        prop: "auditStatus",
        isShow: true,
        width: "200"
      }, {
        name: "创建时间",
        prop: "createTime",
        isShow: true,
        width: "200"
      }],
      funBtns: [{
        size: "small",
        click: "moreAudit",
        icon: "el-icon-edit-outline",
        name: "批量审核",
        type: "primary"
      }, {
        size: "small",
        click: "add",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }
      // {
      //   size: "small",
      //   click: "resetPSW",
      //   icon: "el-icon-refresh",
      //   name: "重置密码",
      //   type: "primary"
      // }
      ],
      minWidth: 300,
      totalData: 0,
      listData: [],
      options: [{
        name: "审核",
        class: "edit",
        option: "audit",
        span: 3,
        field: {
          name: "auditStatus",
          value: "待审核"
        }
      }, {
        name: "编辑",
        class: "edit",
        option: "editInfo",
        span: 3
      }, {
        name: "重置密码",
        class: "delet",
        option: "resetPSW",
        span: 3
      }, {
        name: "删除",
        class: "delet",
        option: "delMsg",
        span: 3
      }],
      formatters: {
        sex: [{
          name: "男",
          value: 1
        }, {
          name: "女",
          value: 0
        }],
        type: [{
          name: "学生",
          value: "1"
        }, {
          name: "教师",
          value: "2"
        }]
      },
      sort: {
        prop: "",
        order: ""
      },
      expertId: "",
      keyWords: "",
      checkBoxs: [],
      reg1: false,
      regList: [{
        name: "教师注册"
      }, {
        name: "学生注册"
      }],
      form: {
        businessId: "",
        achievement: "",
        classes: "",
        fax: "",
        id: "",
        idCard: "",
        mail: "",
        major: "",
        mobile: "",
        name: "",
        nation: "",
        phone: "",
        registerType: 2,
        schoolId: "",
        sex: "",
        title: "",
        type: "",
        userId: "",
        zipCode: ""
      },
      regRules: {
        name: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }, {
          min: 2,
          max: 30,
          message: "长度在 2 到 30 个字符",
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: "请输入职称",
          trigger: "blur"
        }],
        idCard: [{
          required: true,
          message: "请输入身份证号",
          trigger: "blur"
        }, {
          validator: _validate.validateIdNo,
          trigger: "blur"
        }],
        phone: [{
          required: true,
          message: "请输入手机号码",
          trigger: "blur"
        }, {
          validator: _validate.validatePhoneTwo,
          trigger: "blur"
        }],
        mail: [{
          required: true,
          message: "请输入电子邮箱",
          trigger: "blur"
        }, {
          validator: _validate.validateEMail,
          trigger: "blur"
        }],
        sex: [{
          required: true,
          message: "请选择性别",
          trigger: "change"
        }],
        nation: [{
          required: true,
          message: "请输入民族",
          trigger: "blur"
        }],
        major: [{
          required: true,
          message: "请输入所学专业",
          trigger: "blur"
        }],
        classes: [{
          required: true,
          message: "请输入所在年级",
          trigger: "blur"
        }],
        schoolId: [{
          required: true,
          message: "请输入所属学校",
          trigger: "change"
        }],
        type: [{
          required: true,
          message: "请选择注册类型",
          trigger: "change"
        }]
      },
      page: {
        pageSize: 5,
        pageNumber: 1
      },
      bsId: "",
      schoolList: [],
      auditDia: false,
      auditForm: {
        status: "1",
        reason: ""
      },
      changeId: "",
      noType: false,
      editForm: {
        businessId: "",
        achievement: "",
        classes: "",
        fax: "",
        id: "",
        idCard: "",
        mail: "",
        major: "",
        mobile: "",
        name: "",
        nation: "",
        phone: "",
        registerType: 2,
        schoolId: "",
        sex: "",
        title: "",
        type: "",
        userId: "",
        zipCode: ""
      }
    };
  },
  methods: {
    // 提交修改信息
    submitEdit: function submitEdit() {
      var _this = this;
      this.editForm.registerType = 2;
      (0, _user.editRegInfo)(this.editForm).then(function (res) {
        _this.$message.success("操作成功。");
        _this.getRegList();
        _this.editDia = false;
      });
    },
    // 编辑信息
    editInfo: function editInfo(e) {
      this.getSchool();
      this.editDia = true;
      this.getInfoReg(e);
    },
    // 删除
    delMsg: function delMsg(e) {
      var _this2 = this;
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _user.delregInfo)({
          id: e.id
        }).then(function (res) {
          _this2.$message.success("删除成功。");
          _this2.getRegList();
        });
      });
    },
    // 批量审核
    moreAudit: function moreAudit() {
      if (this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else {
        this.auditDia = true;
      }
    },
    // 提交审核
    submitAudit: function submitAudit() {
      var _this3 = this;
      var type = this.auditForm.status;
      (0, _user.auditRegister)({
        idList: this.checkBoxs,
        reason: this.auditForm.reason
      }, type).then(function (res) {
        _this3.auditDia = false;
        _this3.auditForm = {
          status: "1",
          reason: ""
        };
        _this3.$message.success("操作成功。");
        _this3.getRegList();
      });
    },
    // 审核
    audit: function audit(e) {
      this.checkBoxs = [];
      this.auditDia = true;
      this.checkBoxs.push(e.id);
    },
    // 重置密码
    resetPSW: function resetPSW(e) {
      var _this4 = this;
      (0, _user.resetPsd)({
        id: e.userId
      }).then(function (res) {
        _this4.$message.success("操作成功。");
        _this4.getRegList();
      });
    },
    // 注册
    onSubmit: function onSubmit(val) {
      var _this5 = this;
      this.form.businessId = _jsCookie.default.get("businessId");
      this.$refs[val].validate(function (valid) {
        if (valid) {
          var param = _this5.form;
          (0, _user.registerRole)(param).then(function (res) {
            _this5.$message.success("注册成功。");
            _this5.reg1 = false;
            _this5.getRegList();
          });
        }
      });
    },
    tabs: function tabs(index, id) {
      this.tabsActNum = index;
      if (index == 0) {
        this.form.type = 2;
      } else {
        this.form.type = 1;
      }
    },
    // 筛选
    search: function search(e) {
      this.keyWords = e.name;
      this.getRegList();
    },
    // 新增
    add: function add() {
      this.getSchool();
      this.form = {
        businessId: "",
        achievement: "",
        classes: "",
        fax: "",
        id: "",
        idCard: "",
        mail: "",
        major: "",
        mobile: "",
        name: "",
        nation: "",
        phone: "",
        registerType: 2,
        schoolId: "",
        sex: "",
        title: "",
        type: "",
        userId: "",
        zipCode: ""
      };
      this.diaTitle = "新增";
      this.reg1 = true;
    },
    active: function active() {},
    handleSelectionChange: function handleSelectionChange(e) {
      var _this6 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this6.checkBoxs.push(item.id);
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getRegList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getRegList();
    },
    // 获取学校id
    getSchool: function getSchool() {
      var _this7 = this;
      (0, _user.getSchoolLIST)({
        param: this.prCode
      }).then(function (res) {
        _this7.schoolList = res.data;
      });
    },
    // 获取本学校下的注册列表
    getRegList: function getRegList() {
      var _this8 = this;
      (0, _user.registerLsit)({
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        param: this.keyWords
      }, -1).then(function (res) {
        var data = res.data;
        _this8.listData = data.list;
        _this8.listData.forEach(function (item) {
          if (item.auditStatus == 1) {
            item.auditStatus = "已通过";
          } else if (item.auditStatus == 2) {
            item.auditStatus = "已拒绝";
          } else {
            item.auditStatus = "待审核";
          }
        });
        _this8.totalData = data.total;
      });
    },
    // 获取注册表信息
    getInfoReg: function getInfoReg(e) {
      var _this9 = this;
      (0, _user.getregInfo)({
        id: e.userId
      }).then(function (res) {
        _this9.editForm = res.data;
      });
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    this.form.schoolId = this.$store.state.user.userInfo.schoolId;
    // console.log(this.$store.state.user.userInfo.schoolId,'da');
    this.getRegList();
  }
};